import React, { useState, useEffect, useRef } from "react";
import { db } from "../firebase";
import {
  doc,
  getDoc,
  getDocs,
  updateDoc,
  addDoc,
  collection,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp,
} from "firebase/firestore/lite";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Container,
  FormControlLabel,
  FormGroup,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  useMediaQuery,
  Modal,
  Box,
  Typography,
  Switch,
  IconButton,
} from "@mui/material";
import styled from "styled-components";
import { Link, useParams } from "react-router-dom";
import { BEGIN_TEST, FINISH, VOCAB_TEST, VOCABULARY, getDeviceInfo } from "./helper";
import { getConnectivity } from "./connectivityCheck";
import AudioRecorder1 from "./AudioRecorder1";
import Banner from "./Banner";
// DEPRECATED (CDT-256): ListeningAssessment — legacy "listening" step.
// Import disabled; component file retained. Delete after prod verification.
// import ListeningAssessment from "./ListeningAssessment";
import GrammerAssessment from "./GrammerAssessment";
import TypingTest from "./TypingTest";
import MySpinner from "./MySpinner";
import SoftBox from "./SoftBox";
import SoftButton from "./SoftButton";
import SoftTypography from "./SoftTypography";
import TagManager from "react-gtm-module";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "../CustomProgressBar.css";
import orangeClockLogo from "../assets/images/small-logos/fi-sr-clock-orange.svg";
import redClockLogo from "../assets/images/small-logos/fi-sr-clock-red.svg";
import dotLogo from "../assets/images/small-logos/dotLogo.svg";
import cameraLogo from "../assets/images/small-logos/cameraLogo.svg";
import microphoneLogo from "../assets/images/small-logos/microphoneLogo.svg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

const StyledButton = styled(Button)`
  flex-grow: 1;
  // position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`;

export default function Assessment() {
  const [region, setRegion] = useState();
  const [testName, setTestName] = useState("");
  const [selectedTest, setSelectedTest] = useState("");
  const [regions, setRegions] = useState([]);
  const [steps1, setSteps1] = useState([BEGIN_TEST, FINISH]);
  const [user, setUser] = useState();
  const [assessment, setAssessment] = useState();
  const [isLoading, setIsLoading] = useState();
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  // Guards Begin against firing more than once for one assessment.
  const beginInFlight = useRef(false);
  // Drives the button's disabled state and label while Begin is running.
  const [isStarting, setIsStarting] = useState(false);
  const [passage1, setPassage1] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [localStorageRegion, setLocalStorageRegion] = useState([]);
  const [isBeforeFinish, setIsBeforeFinish] = useState([]);
  const [timeSpent, setTimeSpent] = useState(0);
  const [warningVisible, setWarningVisible] = useState(false);
  const [warningText, setWarningText] = useState("");
  const [warningStyle, setWarningStyle] = useState({ color: "#FFAD01" });
  const [isFadingTimeLeft, setIsFadingTimeLeft] = useState(false);
  const [isFadingExceeded, setIsFadingExceeded] = useState(false);
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const [warningType, setWarningType] = useState(null);
  const [timeElapsed, setTimeElapsed] = useState(0); // Track elapsed time for the entire assessment
  const [timeLimit, setTimeLimit] = useState(0); // Time limit for Assessment in seconds
  const [intervalId, setIntervalId] = useState(null); // Track the interval ID to clear it later
  const [totalSections, setTotalSections] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [ListeningSize, setListeningSize] = useState(0);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [permissionsGranted, setPermissionsGranted] = useState(false);
  const [mediaStream, setMediaStream] = useState(null);
  const [micEnabled, setMicEnabled] = useState(false);
  const [camEnabled, setCamEnabled] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [mediaEnabled, setMediaEnabled] = useState(false);
  const [capturedImages, setCapturedImages] = useState(() => {
    const savedImages = localStorage.getItem(
      `capturedImages_${assessment?.uid}`
    );
    return savedImages ? JSON.parse(savedImages) : [];
  });
  const [lastCapturedStep, setLastCapturedStep] = useState(null);
  const isCaptureEnabled = process.env.REACT_APP_CAPTURE_IMAGE === "true";

  // DEPRECATED (CDT-256): loadAudio / loadAudioFile.
  // These bundled the legacy listening prompts from public/listening/*.mp3 for
  // the old "listening" step. Every region test using that step is now marked
  // deprecated; current listening audio is served from REACT_APP_STATIC_REPO.
  // Kept commented rather than deleted — remove in the iteration after prod.
  //
  // async function loadAudio(audioName, jsonName, fileName) {
  //   const audio = await import(`../../public/listening/${audioName}`);
  //   const json = await import(`../../public/listening/${jsonName}`);
  //   const jsonData = json.default.filter((item) => item.question !== "");
  //   return { audio_file: audio.default, json_file: jsonData, file_name: fileName };
  // }
  //
  // const loadAudioFile = async (list) => {
  //   const shuffledList = [...list];
  //   for (let i = shuffledList.length - 1; i > 0; i--) {
  //     const j = Math.floor(Math.random() * (i + 1));
  //     [shuffledList[i], shuffledList[j]] = [shuffledList[j], shuffledList[i]];
  //   }
  //   const list1 = shuffledList.slice(0, 1);
  //   return Promise.all(list1.map((item) => loadAudio(item + ".mp3", item + ".json", item)));
  // };

  useEffect(() => {
    if (steps1[currentStep] === "Finish") {
      stopMediaStream();
      localStorage.removeItem("timeSpent");
      localStorage.removeItem(`timeSpent-${userEmail}`);
      localStorage.removeItem("warningDismissed");

      clearInterval(intervalId); // Stop the timer
      setTimeElapsed(0); // Reset timeElapsed to 0 when the assessment is finished
      // setRegion("");

      const updateAssessment = async () => {
        try {
          const response = await fetch(
            process.env.REACT_APP_SERVER_URL + "/update_assessment_status",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                assessmentUid: assessment.uid,
                testName: testName,
              }),
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          console.log("Assessment updated successfully");
        } catch (error) {
          console.error("Error updating assessment:", error);
        }
      };
      updateAssessment();
      // setSelectedTest("");
      localStorage.removeItem("localTestName");
    }
  }, [currentStep]);

  useEffect(() => {
    if (region && selectedTest) {
      const selectedTestDetails = region["tests"][selectedTest];
      const topics = selectedTestDetails.sections.map(
        (section) => section.topic
      );
      const testNameData = region["tests"][selectedTest]?.Name;
      setTestName(testNameData);
      localStorage.setItem("localTestName", testNameData);
      // Update the steps1 array
      setSteps1([BEGIN_TEST, ...topics, FINISH]);
      setIsBeforeFinish([BEGIN_TEST, ...topics, FINISH]);
      setTimeLimit(region["tests"][selectedTest]["time_limit"]);
      const sectionData = region["tests"][selectedTest]["sections"];
      const totalQuestions = sectionData.reduce((total, section) => {
        // Ensure section.size is a valid number
        const size = typeof section.size === "number" ? section.size : 0;
        return total + size;
      }, 0);
      setTotalSections(sectionData.length);
      setTotalQuestions(totalQuestions);
    }
  }, [selectedTest]);

  useEffect(() => {
    const regionsData = [];
    const localStorageRegion = sessionStorage.getItem("region");
    setLocalStorageRegion(localStorageRegion);
    const regionRef = collection(db, "regions");
    getDocs(regionRef)
      .then(async (querySnapshot) => {
        querySnapshot.forEach((docSnapshot) => {
          regionsData.push(docSnapshot.data());
        });
        setRegions(regionsData);
      })
      .catch((error) => {
        console.error("Error getting document: ", error);
      });

  }, []);

  let { q } = useParams();
  useEffect(() => {
    setIsLoading(true);
    const userRef = doc(db, "users", q);

    getDoc(userRef)
      .then(async (docSnapshot) => {
        if (docSnapshot.exists()) {
          const userData = docSnapshot.data();
          let isCreateNewAssessment = false;
          const q1 = query(
            collection(db, "assessments"),
            where("userId", "==", docSnapshot.id),
            orderBy("createdAt", "desc"),
            limit(1)
          );
          let region_obj = null;

          const querySnapshot = await getDocs(q1);
          if (querySnapshot.empty) {
            isCreateNewAssessment = true;
          } else {
            const assessement1 = querySnapshot.docs[0].data();

            if (assessement1 && assessement1.region) {
              const q2 = query(
                collection(db, "regions"),
                where("region", "==", assessement1.region)
              );
              const regionSnapshot = await getDocs(q2);
              region_obj = regionSnapshot.docs[0].data();
            }

            if (assessement1.currentStep === "Finish") {
              isCreateNewAssessment = false;
              const stepIndex = steps1.indexOf(assessement1.currentStep);
              setRegion(region_obj);
              setCurrentStep(stepIndex);
            } else {
              assessement1.uid = querySnapshot.docs[0].id;
              setAssessment(assessement1);
              setQuestions(assessement1);

              setPassage1(assessement1?.passage);
              setListeningSize(assessement1?.listening_size);
              // DEPRECATED (CDT-256): legacy bundled listening audio.
              // if (assessement1?.audio_file) {
              //   setAudioFiles(await loadAudioFile([assessement1.audio_file]));
              // }

              setRegion(region_obj);
              const steps2 = [BEGIN_TEST];
              const selectedTestData =
                region_obj?.tests[assessement1.test_name];

              if (selectedTestData?.sections) {
                setTestName(selectedTestData.Name);
                setSelectedTest(assessement1.test_name);
                // Map sections to extract topics
                const topics = selectedTestData.sections.map(
                  (section) => section.topic
                );

                // Update steps1 with BEGIN_TEST, topics, and FINISH
                setSteps1([BEGIN_TEST, ...topics, FINISH]);
                setIsBeforeFinish([BEGIN_TEST, ...topics, FINISH]);
                steps2.push(...topics);
                steps2.push(FINISH);
              }

              const stepIndex = steps2.indexOf(
                assessement1.currentStep || BEGIN_TEST
              );

              setCurrentStep(stepIndex);

              // Log device info on assessment load/resume
              try {
                const stepKey = assessement1.currentStep || BEGIN_TEST;
                const info = getDeviceInfo(stepKey);
                delete info.step;
                updateDoc(doc(collection(db, "assessments"), assessement1.uid), {
                  [`device_logs.${stepKey}`]: info,
                }).catch((err) => console.error("Device log error:", err));
              } catch (e) {}
            }
          }
          // for external user
          if (isCreateNewAssessment) {
            await createNewAssessment(userData);
          }
          setUser(userData);

          TagManager.dataLayer({
            dataLayer: {
              event: "component_loaded",
              component: "Assessment",
              userData: userData,
            },
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error getting document: ", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [q]);

  const handleInitialSubmit = () => {
    // Begin must run exactly once. This is reachable from three places in the
    // permission flow, and every call used to fetch questions and then do
    // setCurrentStep(prev + 1). Two calls meant two increments, so the
    // candidate landed on steps[2] and never saw the first section -- in
    // practice cefr_reading, which is steps[1] on every assessment that has
    // it. 28 candidates in 15 days finished with 8 reading questions
    // assigned, none answered, and no reading score.
    //
    // A ref, not state: state would not have settled before a second call
    // arrived on the same tick.
    if (beginInFlight.current) {
      console.warn("Begin already started for this assessment - ignoring");
      return;
    }
    beginInFlight.current = true;

    sessionStorage.removeItem("region");
    sessionStorage.removeItem("isRegion");
    localStorage.removeItem("timeSpent");
    localStorage.removeItem(`timeSpent-${userEmail}`);
    localStorage.removeItem("warningDismissed");

    try {
      setIsLoading(true);
      setRegion(region);

      const apiUrl = `${process.env.REACT_APP_SERVER_URL}/get_questions?region=${region.region}&test_name=${selectedTest}&assessment=${assessment.uid}`;
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };

      fetch(apiUrl, options)
        .then(async (response) => response.json())
        .then(async (data) => {
          setQuestions(data);
          if (data?.reading) {
            setPassage1(data?.reading?.passage1);
          }
          setListeningSize(data?.listening_size);
          // DEPRECATED (CDT-256): legacy bundled listening audio.
          // if (data?.listening?.field) {
          //   setAudioFiles(await loadAudioFile([data?.listening?.field]));
          // }
          setIsLoading(false);
          handleNextStep();
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          // Begin did not happen, so let her press it again.
          beginInFlight.current = false;
          setIsStarting(false);
          setIsLoading(false);
        });
    } catch (error) {
      console.log(error);
      beginInFlight.current = false;
      setIsStarting(false);
      setIsLoading(false);
    }
  };

  const logDeviceInfo = (stepName) => {
    if (!assessment?.uid || !stepName) return;
    try {
      const info = getDeviceInfo(stepName);
      delete info.step;
      updateDoc(doc(collection(db, "assessments"), assessment.uid), {
        [`device_logs.${stepName}`]: info,
      }).catch((err) => console.error("Device log error:", err));
    } catch (e) {
      console.error("getDeviceInfo error:", e);
    }

    // Corporate networks frequently block the static media host, which the
    // candidate only experiences as "the audio won't play". Probe it once, on
    // the steps that need audio, and record the result alongside the device log.
    //
    // Deliberately NOT awaited: the step advances immediately and the result is
    // patched in whenever it lands. A slow or hanging probe cannot delay the test.
    if (stepName === "cefr_listening" || stepName === "listening") {
      getConnectivity(stepName)
        .then((result) => {
          updateDoc(doc(collection(db, "assessments"), assessment.uid), {
            [`device_logs.${stepName}.connectivity`]: result.connectivity,
          }).catch((err) => console.error("Connectivity log error:", err));
        })
        .catch((err) => console.error("Connectivity probe error:", err));
    }
  };

  const handleNextStep = () => {
    logDeviceInfo(steps1[currentStep] || "unknown");
    setCurrentStep((prevStep) => prevStep + 1);
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  }, [currentStep]);

  const createNewAssessment = async (userData) => {
    localStorage.removeItem("timeSpent");
    localStorage.removeItem(`timeSpent-${userEmail}`);
    localStorage.removeItem("warningDismissed");
    setTimeSpent(0);
    setWarningType(null);

    if (userData.region) {
      const q2 = query(
        collection(db, "regions"),
        where("region", "==", userData.region)
      );
      const regionSnapshot = await getDocs(q2);
      const region = regionSnapshot.docs[0].data();
      setRegion(region);
    }
    const assessment1 = {
      userId: userData.uid,
      createdAt: serverTimestamp(),
      currentStep: BEGIN_TEST,
      test_name: userData.test_name,
      ...(userData.region && { region: userData.region }),
    };
    const assessRef = collection(db, "assessments");

    addDoc(assessRef, assessment1)
      .then((docRef) => {
        assessment1.uid = docRef.id;
        setAssessment(assessment1);
        setCurrentStep(0);
        // A new assessment gets a fresh Begin.
        beginInFlight.current = false;
        setIsStarting(false);
        updateDoc(doc(collection(db, "users"), userData.uid), {
          currentStep: BEGIN_TEST,
          resultStatus: "Initial",
        }).then((userDocRef) => {
          console.log("Updated the user ", userDocRef);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handlePrevStep = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const getButtons = () => {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {currentStep > 0 ? (
          <StyledButton onClick={handlePrevStep}>Previous</StyledButton>
        ) : (
          <StyledButton style={{ visibility: "hidden" }}>Previous</StyledButton>
        )}
        {currentStep < 4 ? (
          <StyledButton onClick={() => handleNextStep()}>Next</StyledButton>
        ) : (
          <StyledButton style={{ visibility: "hidden" }}>Next</StyledButton>
        )}
      </div>
    );
  };

  const [isBelow1200, setIsBelow1200] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsBelow1200(window.innerWidth < 1200);
    };

    handleResize(); // set initially
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // const renderRegionButton = (region1) => {
  const renderRegionButton = (region1, setShowPermissionModal) => {
    const assessmentName = regions.find(
      (r) => r.region === region1
    )?.assessment_name;
    return (
      <SoftBox mt={4} mb={1}>
        <SoftButton
          variant="contained"
          color="gt_primary"
          onClick={() => {
            if (isStarting) return;
            if (isDev) {
              setIsStarting(true);
              handleInitialSubmit();
            } else {
              setShowPermissionModal(true);
            }
          }}
          disabled={isStarting}
          fullWidth
        >
          {isStarting ? "Starting…" : testName}
        </SoftButton>
      </SoftBox>
    );
  };

  useEffect(() => {
    if (isDev) return;
    const storedStream = localStorage.getItem("mediaStreamUrl");
    if (storedStream) {
      navigator.mediaDevices
        .getUserMedia({ video: true, audio: true })
        .then((stream) => {
          setMediaStream(stream);
          setPermissionsGranted(true);
        })
        .catch((error) => {
          console.error("Error reinitializing media stream:", error);
          alert("Camera and microphone access required.");
        });
    }
  }, [currentStep]);

  useEffect(() => {
    const storedStream = localStorage.getItem("mediaStreamUrl");
    if (storedStream && !mediaStream) {
      navigator.mediaDevices
        .getUserMedia({ video: true, audio: true })
        .then(async (stream) => {
          setMediaStream(stream);
          setPermissionsGranted(true);

          const video = videoRef.current;
          if (video) {
            video.srcObject = stream;
            await new Promise((resolve) => {
              video.onloadedmetadata = () => {
                video.play().then(resolve).catch(resolve);
              };
            });
          }
        })
        .catch((error) => {
          console.error("Error reinitializing media stream:", error);
          alert("Camera and microphone access required.");
        });
    }
  }, [mediaStream]);

  useEffect(() => {
    if (mediaStream && videoRef.current) {
      videoRef.current.srcObject = mediaStream;
    }
  }, [mediaStream]);

  const isDev = process.env.REACT_APP_ENV === "DEV";

  const requestPermissions = async (
    setPermissionsGranted,
    setShowPermissionModal,
    handleInitialSubmit
  ) => {
    // In DEV mode, skip camera/microphone enforcement
    if (isDev) {
      setPermissionsGranted(true);
      setShowPermissionModal(false);
      handleInitialSubmit();
      return;
    }

    try {
      // Request both camera AND microphone access
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      setMediaStream(stream);
      setPermissionsGranted(true);
      localStorage.setItem("mediaStreamUrl", "active");

      const video = videoRef.current;
      if (video) {
        video.srcObject = stream;

        await new Promise((resolve) => {
          video.onloadedmetadata = () => {
            video.play().then(resolve).catch(resolve);
          };
        });

        let tries = 0;
        while (
          (video.videoWidth === 0 || video.videoHeight === 0) &&
          tries < 30
        ) {
          console.log("⏳ Waiting for video to be ready...");
          await new Promise((r) => setTimeout(r, 200));
          tries++;
        }

        if (video.videoWidth === 0) {
          console.error("❌ Video still not ready");
          alert(
            "Camera is not rendering. Please refresh or check permissions."
          );
          return;
        }

        setShowPermissionModal(false);
        handleInitialSubmit();
      } else {
        console.error("❌ videoRef is null");
      }
    } catch (err) {
      console.error("getUserMedia failed:", err);
      alert(
        "Camera or microphone access failed. Please check your device permissions."
      );
    }
  };

  const stopMediaStream = () => {
    if (mediaStream) {
      mediaStream.getTracks().forEach((track) => track.stop());
      setMediaStream(null);
      localStorage.removeItem("mediaStreamUrl");
    }
  };

  useEffect(() => {
    if (assessment?.uid) {
      const savedImages = localStorage.getItem(
        `capturedImages_${assessment.uid}`
      );
      if (savedImages) {
        setCapturedImages(JSON.parse(savedImages));
      }
    }
  }, [assessment?.uid]);

  const captureAndSubmitImage = async () => {
    if (!isCaptureEnabled || capturedImages.length >= 5 || !mediaStream) return;

    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (!video || !canvas || video.videoWidth === 0) {
      console.error("Video not ready or canvas/video is null");
      return;
    }

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob(async (blob) => {
      if (!blob) {
        console.error("Failed to capture canvas blob");
        return;
      }

      const newImages = [...capturedImages, URL.createObjectURL(blob)];
      setCapturedImages(newImages);
      localStorage.setItem(
        `capturedImages_${assessment?.uid}`,
        JSON.stringify(newImages)
      );

      const formData = new FormData();
      formData.append("image", blob, "capture.jpg");
      formData.append("assessment_uid", assessment?.uid);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/update_image`,
          {
            method: "POST",
            body: formData,
          }
        );

        const data = await response.json();
        if (data.imageUrl) {
          setImageUrls((prevUrls) => [...prevUrls, data.imageUrl]);
        }
      } catch (error) {
        console.error("Upload failed:", error);
      }
    }, "image/jpeg");
  };

  useEffect(() => {
    if (
      isCaptureEnabled &&
      currentStep !== lastCapturedStep &&
      capturedImages.length < 5
    ) {
      captureAndSubmitImage();
      setLastCapturedStep(currentStep);
    }
  }, [currentStep]);

  useEffect(() => {
    if (capturedImages.length >= 5) {
      console.log("Maximum images captured");
    }
  }, [capturedImages]);

  useEffect(() => {
    return () => {
      if (!assessment?.uid) {
        localStorage.removeItem(`capturedImages_${assessment?.uid}`);
      }
      if (mediaStream) {
        mediaStream.getTracks().forEach((track) => track.stop());
      }
    };
  }, [assessment?.uid, mediaStream]);

  useEffect(() => {
    if (currentStep === "FINISH") {
      console.log("Captured Image URLs:", imageUrls);
      setCapturedImages([]);
      localStorage.removeItem(`capturedImages_${assessment?.uid}`);
    }
  }, [currentStep, imageUrls]);

  // Function to render the tests dropdown for a selected region
  const renderTestsDropdown = (region) => (
    <FormControl
      size="small"
      sx={{
        marginBottom: "16px",
        width: "250px",
        marginTop: "30px",
      }}
    >
      <InputLabel sx={{ fontSize: "1rem" }}>Select the Tests</InputLabel>
      <Select
        value={selectedTest}
        onChange={(event) => {
          setSelectedTest(event.target.value);
        }}
        sx={{
          "& .MuiSelect-select": {
            minWidth: "100%",
          },
        }}
      >
        <MenuItem value="">Select Test</MenuItem>
        {Object.keys(region.tests).map((testKey) => {
          // Ensure that 'False' is actually 'false' (boolean, not string)
          if (region.tests[testKey].deprecated === false) {
            return (
              <MenuItem key={testKey} value={testKey}>
                {region.tests[testKey].Name}
              </MenuItem>
            );
          }
          return null; // If deprecated is true, return null to avoid rendering the test
        })}
      </Select>
    </FormControl>
  );

  // Function to render the regions dropdown
  const renderRegionsDropdown = () => (
    <FormControl
      size="small"
      sx={{
        width: "100%",
        width: "250px",
        marginTop: "30px",
      }}
    >
      <InputLabel sx={{ fontSize: "1rem" }}>Select Region</InputLabel>
      <Select
        value={region ? region.region : ""}
        onChange={(event) => {
          const selectedRegion = regions.find(
            (r) => r.region === event.target.value
          );
          setRegion(selectedRegion);
          setSelectedTest(""); // Reset test selection on region change
        }}
        sx={{
          "& .MuiSelect-select": {
            minWidth: "100%",
          },
        }}
      >
        <MenuItem value="">Select Region</MenuItem>
        {regions.map((regionData) => (
          <MenuItem key={regionData.region} value={regionData.region}>
            {regionData.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  const renderContent = () => {
    if (selectedTest) {
      // return renderRegionButton(region?.region || localStorageRegion);
      return renderRegionButton(
        region?.region || localStorageRegion,
        setShowPermissionModal
      );
    } else if (localStorageRegion) {
      return renderRegionButton(localStorageRegion);
    } else if (region) {
      setSelectedTest(user.test_name);
      // if(Object.keys(region.tests).length > 1){
      //   return renderTestsDropdown(region);
      // }else{
      //   const keyName = Object.keys(region.tests)[0];
      //   setSelectedTest(keyName);
      // }
    } else {
      return renderRegionsDropdown();
    }
  };

  const RenderContent = () => {
    return (
      <>
        {renderContent()}

        {/* Permission Modal */}
        <Modal
          open={showPermissionModal}
          onClose={() => setShowPermissionModal(true)}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 420,
              bgcolor: "#f8f9fa",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              color: "#333",
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h6" fontWeight="bold">
                Ensure a Smooth Experience
              </Typography>
              <IconButton
                onClick={() => setShowPermissionModal(false)}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Typography variant="body2" mb={3}>
              To proceed with the assessment, please enable access to your
              microphone and camera. This helps us verify your identity
              seamlessly while you take the test.
            </Typography>

            {/* Combined Media Switch */}
            <SoftBox
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt={2}
              p={1}
              sx={{ bgcolor: "#e9ecef", borderRadius: 1 }}
            >
              <Typography fontWeight="medium">Camera & Microphone</Typography>
              <Switch
                checked={mediaEnabled}
                onChange={(e) => setMediaEnabled(e.target.checked)}
              />
            </SoftBox>

            {/*
              requestPermissions is slow: it asks the browser for the camera
              and microphone, waits for her to allow it, then waits again for
              the video element to render, and only then starts the test.
              Several seconds with no feedback at all -- the button stayed
              enabled, still said "Start", and the spinner only appeared later
              because setIsLoading lives inside handleInitialSubmit. So she
              pressed it again, and the second press skipped her first section.
              Disabling on press is the actual fix; the guard inside
              handleInitialSubmit is the safety net behind it.
            */}
            <SoftButton
              variant="contained"
              color="gt_primary"
              fullWidth
              onClick={async () => {
                if (isStarting) return;
                setIsStarting(true);
                try {
                  await requestPermissions(
                    setPermissionsGranted,
                    setShowPermissionModal,
                    handleInitialSubmit
                  );
                } finally {
                  setIsStarting(false);
                }
              }}
              disabled={isStarting || (!isDev && !mediaEnabled)}
              sx={{ mt: 4, py: 1.5, fontSize: "1rem", fontWeight: "bold" }}
            >
              {isStarting ? "Starting…" : "Start"}
            </SoftButton>
          </Box>
        </Modal>
      </>
    );
  };

  // Function to format time in mm:ss format
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  const userEmail = user?.email || ""; // Get the user email

  // Load saved timeSpent from localStorage when the page loads
  useEffect(() => {
    const savedTime = localStorage.getItem(`timeSpent-${userEmail}`); // Use user email to create a unique key
    if (savedTime) {
      setTimeSpent(parseInt(savedTime, 10));
    }
  }, [userEmail]);

  // Save the timer value to localStorage whenever timeSpent changes
  useEffect(() => {
    if (userEmail) {
      localStorage.setItem(`timeSpent-${userEmail}`, timeSpent); // Save timeSpent with the unique key for the user
    }
  }, [timeSpent, userEmail]);

  useEffect(() => {
    // Wait for the page to load
    const onPageLoad = () => {
      setIsPageLoaded(true);
    };

    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
    }

    return () => {
      window.removeEventListener("load", onPageLoad);
    };
  }, []);

  useEffect(() => {
    let fadeTimeout;
    let fadeTimeoutForTimeLeft;

    // Use currentStepName based on steps1 and currentStep
    const currentStepName = steps1[currentStep];

    if (currentStepName === "BEGIN_TEST") {
      setTimeSpent(0);
    }
    // Skip if the page isn't loaded or the currentStep is "Finish" or "BEGIN_TEST"
    if (
      !isPageLoaded ||
      currentStepName === "Finish" ||
      currentStepName === "BEGIN_TEST"
    )
      return;

    const timer = setInterval(() => {
      setTimeSpent((prevTime) => {
        const newTime = prevTime + 1;

        // Handle the "exceeded" warning
        if (newTime > timeLimit && !isFadingExceeded) {
          setWarningText(
            "You have exceeded the time limit for assessment. While you can continue and complete the assessment, please manage your time carefully in the remaining assessment."
          );
          setWarningStyle({ color: "#D92D20" });
          setWarningVisible(true);
          setWarningType("exceeded");
          setIsFadingExceeded(false); // Keep it visible initially

          // Set fade-out for "exceeded" warning after 10 seconds
          fadeTimeout = setTimeout(() => {
            setIsFadingExceeded(true); // Fade out after 10 seconds
          }, 10000);
        }

        // Handle the "timeLeft" warning when 20 seconds remain
        if (
          newTime >= timeLimit - 20 &&
          newTime < timeLimit &&
          !isFadingTimeLeft &&
          !isFadingExceeded
        ) {
          setWarningText(
            "Time is almost up for this section. You have approximately 20 seconds remaining. Please manage your time carefully to complete the assessment."
          );
          setWarningStyle({ color: "#FFAD01" });
          setWarningVisible(true);
          setWarningType("timeLeft");
          setIsFadingTimeLeft(false); // Keep the "timeLeft" warning visible initially

          // Set fade-out for "timeLeft" warning after 10 seconds
          fadeTimeoutForTimeLeft = setTimeout(() => {
            setIsFadingTimeLeft(true); // Fade out after 10 seconds
          }, 10000);
        }

        return newTime;
      });
    }, 1000); // Update every second

    // Cleanup function to stop the timer on step change or warning dismissal
    return () => {
      clearInterval(timer);
      clearTimeout(fadeTimeout);
      clearTimeout(fadeTimeoutForTimeLeft);
      setWarningVisible(false); // Hide the warning
    };
  }, [
    isPageLoaded,
    currentStep,
    timeSpent,
    selectedTest,
    warningType,
    isFadingExceeded,
    isFadingTimeLeft,
  ]);

  const beginTestComponent = () => {
    return (
      <>
        {user && (
          <Container>
            <SoftBox
              sx={{
                backgroundColor: "primary.contrastText",
                padding: 2,
                borderRadius: "15px",
              }}
            >
              <SoftTypography
                SoftTypography
                variant="h5"
                fontWeight="bold"
                sx={{ color: "#4f4f4f" }}
              >
                Greetings, {`${user.firstName} ${user.lastName}`}
              </SoftTypography>

              <SoftBox mt={1}>
                <SoftTypography
                  variant="h6"
                  fontSize="16px"
                  fontWeight={400}
                  sx={{ color: "#8a8a8a" }}
                >
                  We are excited to welcome you to our Candidate Assessment
                  platform, where you will undergo a comprehensive evaluation of
                  your skills and abilities.
                </SoftTypography>
              </SoftBox>

              <p className="text-center"></p>
              <SoftBox mt={1}>
                <SoftTypography
                  variant="h6"
                  fontWeight="medium"
                  sx={{ color: "#8a8a8a" }}
                >
                  The assessment consists of multiple sections, each designed to
                  measure different aspects of your expertise. Please read each
                  question carefully before answering to ensure accuracy and
                  completeness.
                </SoftTypography>
              </SoftBox>

              <p className="text-center"></p>
              <SoftBox mt={1}>
                <SoftTypography
                  variant="h6"
                  fontWeight="medium"
                  sx={{ color: "#8a8a8a" }}
                >
                  To ensure a smooth assessment experience, we recommend finding
                  a quiet environment, using a stable internet connection, and
                  minimizing potential interruptions. Additionally, kindly
                  review your account information to confirm its accuracy before
                  starting.
                </SoftTypography>
              </SoftBox>
              <p className="text-center"></p>
              <SoftBox mt={1}>
                <SoftTypography
                  variant="h6"
                  fontWeight="medium"
                  sx={{ color: "#8a8a8a" }}
                >
                  We appreciate your time and effort in completing this
                  assessment and wish you the best of luck!
                  <br />
                  <br />
                  {user.email && (
                    <>
                      <EmailOutlinedIcon
                        fontSize="medium"
                        sx={{ color: "#333333" }}
                        style={{ verticalAlign: "middle", marginRight: "8px" }}
                      />{" "}
                      {user.email} <br />
                    </>
                  )}
                </SoftTypography>
              </SoftBox>
            </SoftBox>
            {/* <> {renderContent()}</> */}
            <>
              {" "}
              <RenderContent
                region={region}
                testName={testName}
                handleInitialSubmit={handleInitialSubmit}
              />
            </>
          </Container>
        )}
      </>
    );
  };

  const highlightEmails = (text) => {
    if (!text) return "";
    const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
    return text.replace(
      emailRegex,
      (email) =>
        `<a href="mailto:${email}" style="color:blue; font-weight:bold; text-decoration:underline;">${email}</a>`
    );
  };

  const renderStep = () => {
    // Step 1: Calculate total sections (ignoring BEGIN_TEST and FINISH)
    const totalSections = isBeforeFinish.filter(
      (step) => step !== BEGIN_TEST && step !== FINISH
    ).length;
    const text_msg = `${region?.completion_msg ?? ''} ${region?.email ?? ''}`;

    const message = highlightEmails(text_msg);
    // Step 2: Calculate the current progress
    const currentStepIndex = isBeforeFinish.indexOf(steps1[currentStep]);
    const completedSections = isBeforeFinish
      .slice(0, currentStepIndex)
      .filter((step) => step !== BEGIN_TEST && step !== FINISH).length;

    // Step 3: Progress percentage
    let progress = totalSections
      ? Math.round((completedSections / totalSections) * 100)
      : 0;

    // Handle the "FINISH" step to show 100% progress
    if (steps1[currentStep] === FINISH) {
      progress = 100;
    }

    // Determine the next section name
    let nextValue = "";
    if (
      currentStepIndex !== -1 &&
      currentStepIndex < isBeforeFinish.length - 1
    ) {
      nextValue = isBeforeFinish[currentStepIndex + 1];
    }

    // Step 4: Determine the component to render based on the current step
    let stepComponent = null;
    // const selectedTest1 = region?.tests ? region.tests[selectedTest] : null;
    const step_name = steps1[currentStep];
    let page = "questions";
    if (region && region.tests && region.tests[selectedTest]) {
      if (region.tests[selectedTest].sections) {
        const section = region.tests[selectedTest].sections.find(
          (sec) => sec.topic === step_name
        );
        if (section && section.page) {
          page = section.page;
        }
      }
    }
    // Fallback: if step_name is typing_test, force the page
    if (step_name === "typing_test" && page !== "typing_test") {
      page = "typing_test";
    }


    if (step_name === BEGIN_TEST) {
      stepComponent = beginTestComponent();
    } else if (step_name === FINISH) {
      stepComponent = (
        <Container style={{ marginTop: "12px" }}>
          <SoftBox mt={1} mb={2}>
            <div
              style={{ fontWeight: "500", color: "#344767", fontSize: "1rem" }}
              dangerouslySetInnerHTML={{
                __html:
                  message ||
                  "Thanks for taking the assessment, will get in touch soon.",
              }}
            />
          </SoftBox>
        </Container>
      );
    } else if (page === "questions") {
      let section_questions = questions[steps1[currentStep]];
      if (
        section_questions == null &&
        (steps1[currentStep] === VOCABULARY ||
          steps1[currentStep] === VOCAB_TEST)
      ) {
        section_questions = questions[VOCABULARY] || questions[VOCAB_TEST];
      }
      stepComponent = (
        <GrammerAssessment
          user={user}
          category={steps1[currentStep]}
          assessment={assessment}
          handleNextStep={handleNextStep}
          region={region}
          test={selectedTest}
          questions={section_questions}
          nextSectionName={nextValue}
        />
      );
    } else if (page === "typing_test") {
      const section_questions = questions[steps1[currentStep]];
      stepComponent = (
        <TypingTest
          user={user}
          category={steps1[currentStep]}
          assessment={assessment}
          handleNextStep={handleNextStep}
          region={region}
          test={selectedTest}
          questions={section_questions}
          nextSectionName={nextValue}
        />
      );
    } else if (page === "speaking") {
      const section_questions = questions[steps1[currentStep]];
      stepComponent = (
        <AudioRecorder1
          user={user}
          category={steps1[currentStep]}
          assessment={assessment}
          handleNextStep={handleNextStep}
          region={region}
          test={selectedTest}
          questions={section_questions}
          nextSectionName={nextValue}
          passage={
            (steps1[currentStep].startsWith("speaking_") || steps1[currentStep].startsWith("audio_scenario_"))
              ? section_questions[0]["question"]
              : passage1
          }
          passage2={passage1}
        />
      );
    }
    // switch (steps1[currentStep]) {
    //   case BEGIN_TEST:
    //     stepComponent = beginTestComponent();
    //     break;
    //   case "attendance_es":
    //   case VOCAB_TEST:
    //   case VOCABULARY:
    //   case APT_TEST:
    //   case APTITUDE_TECHNICAL_TEST:
    //   case COMPREHENSIVE_TEST:
    //   case EMOTIONAL_INTELLIGENCE_TEST:
    //   case CUSTOMER_SERVICE_TEST:
    //   case CALL_CENTER_KNOWLEDGE_TEST:
    //   case TECH_SUPPORT:
    //   case SALES_TEST:
    //   case SALES_RETENTION_TEST:
    //   case LISTENING_TEST:
    //   case CEFR_READING_TEST:
    //   case CEFR_WRITING_TEST:
    //   case CEFR_LISTENING_TEST:
    //   case ATTENTION_TO_DETAIL_TEST:
    //   case INTEGRITY_TEST:
    //   case RETENTION_LISTENING_TEST:
    //   case SALES_AUDIO:
    //   case CUSTOMER_SERVICE_AUDIO:
    //   case ATTENDANCE_TEST:
    //   case ALTICE_QUESTIONS_TEST: {
    //     let section_questions = questions[steps1[currentStep]];
    //     if (section_questions == null && (steps1[currentStep] === VOCABULARY || steps1[currentStep] === VOCAB_TEST)){
    //       section_questions = questions[VOCABULARY] || questions[VOCAB_TEST];
    //     }
    //     stepComponent = (
    //       <GrammerAssessment
    //         user={user}
    //         category={steps1[currentStep]}
    //         assessment={assessment}
    //         handleNextStep={handleNextStep}
    //         region={region}
    //         test={selectedTest}
    //         questions={section_questions}
    //         nextSectionName={nextValue}
    //       />
    //     );
    //     break;
    //   }

    //   case READING_TEST:
    //   case steps1[currentStep].startsWith("speaking_")
    //     ? steps1[currentStep]
    //     : null:
    //     const section_questions = questions[steps1[currentStep]];

    //     stepComponent = (
    //       <AudioRecorder1
    //         user={user}
    //         category={steps1[currentStep]}
    //         assessment={assessment}
    //         handleNextStep={handleNextStep}
    //         region={region}
    //         test={selectedTest}
    //         questions={section_questions}
    //         nextSectionName={nextValue}
    //         passage={
    //           steps1[currentStep].startsWith("speaking_")
    //             ? section_questions[0]["question"]
    //             : passage1
    //         }
    //         passage2={passage1}
    //       />
    //     );
    //     break;
    //   case FINISH:
    //     stepComponent = (
    //       <Container style={{ marginTop: "12px" }}>
    //         <SoftBox mt={1} mb={2}>
    //           <SoftTypography variant="body1" fontWeight="medium" color="dark">
    //             Thanks for taking the assessment, will get in touch soon.
    //           </SoftTypography>
    //         </SoftBox>
    //       </Container>
    //     );
    //     break;

    //   default:
    //     stepComponent = null;
    // }

    const progressBar = (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>{`${progress}% completed`}</Tooltip>}
      >
        <div className="custom-progress-bar-container">
          <div
            className="custom-progress-bar"
            style={{ width: `${progress}%` }}
          >
            <div className="circle-container">
              <div className="message-box">{progress}%</div>
              <div className="circle"></div>
            </div>
          </div>
        </div>
      </OverlayTrigger>
    );

    return (
      <>
        {steps1[currentStep] !== BEGIN_TEST &&
          steps1[currentStep] !== FINISH && (
            <div
              style={{
                padding: "5px",
                marginBottom: "15px",
                backgroundColor: "rgba(238, 240, 253, 1)",
                border: "1px solid rgba(204, 210, 250, 1)",
              }}
            >
              <div
                style={{
                  maxWidth: "1200px",
                  marginLeft: isBelow1200 ? "16px" : "110px",
                  marginRight: "16px",
                  color: "rgba(69, 85, 194, 1)",
                  fontSize: "16px",
                  fontWeight: "400",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  position: "relative",
                }}
              >
                {/* Microphone Icon with Green Dot */}
                <div
                  style={{
                    position: "relative",
                    width: "24px",
                    height: "24px",
                  }}
                >
                  <img
                    src={microphoneLogo}
                    alt="Microphone Icon"
                    style={{ width: "100%", height: "100%" }}
                  />
                  <img
                    src={dotLogo}
                    alt="Green Dot"
                    style={{
                      position: "absolute",
                      bottom: "0px",
                      right: "0px",
                      width: "8px",
                      height: "8px",
                    }}
                  />
                </div>

                {/* Camera Icon with Green Dot */}
                <div
                  style={{
                    position: "relative",
                    width: "24px",
                    height: "24px",
                  }}
                >
                  <img
                    src={cameraLogo}
                    alt="Camera Icon"
                    style={{ width: "100%", height: "100%" }}
                  />
                  <img
                    src={dotLogo}
                    alt="Green Dot"
                    style={{
                      position: "absolute",
                      bottom: "0px",
                      right: "0px",
                      width: "8px",
                      height: "8px",
                    }}
                  />
                </div>

                <span>
                  Your assessment is being monitored. Please keep your face
                  visible at all times.
                </span>
              </div>
            </div>
          )}
        <Container
          style={{
            backgroundColor:
              steps1[currentStep] === BEGIN_TEST
                ? "rgba(243, 243, 243, 1)"
                : "#FFFFFF",
            borderRadius: "10px 10px 0px 0px",
          }}
        >
          <SoftBox mt={1} mb={1}>
            <div className="test-name-header">
                <span className="test-title" style={{ fontWeight: "bold" }}>{testName}</span>
                <div className="timer-header-div">
                  <span
                    className={`timer-header ${
                      warningType === "exceeded" ? "warning" : ""
                    }`}
                  >
                    {formatTime(timeSpent)} / {formatTime(timeLimit)}
                  </span>
                </div>
              </div>
          </SoftBox>
          {steps1[currentStep] !== BEGIN_TEST && progressBar}
        </Container>
        <Container
          sx={{
            borderRadius: "0px",
            padding:
              steps1[currentStep] === BEGIN_TEST ? "20px" : "0px !important",
            margin:
              steps1[currentStep] === BEGIN_TEST
                ? "-10px auto 0 auto !important"
                : "-30px auto 30px auto !important",
          }}
        >
          <div
            style={{
              padding: "30px 0 20px 0",
              backgroundColor:
                steps1[currentStep] === BEGIN_TEST
                  ? "rgba(243, 243, 243, 1)"
                  : "#FFFFFF",
            }}
          >
            <hr className="line-breaker-header"></hr>
          </div>
        </Container>
        {stepComponent}
        {warningVisible && (
          <div
            className={`soft-warning 
              ${
                warningType === "timeLeft" && isFadingTimeLeft ? "fade-out" : ""
              } 
              ${
                warningType === "exceeded" && isFadingExceeded ? "fade-out" : ""
              }`}
            style={warningStyle}
          >
            <img
              src={warningType === "exceeded" ? redClockLogo : orangeClockLogo}
              alt="Clock Icon"
              style={{
                marginLeft: "18px",
                left: "0",
                marginTop: "20px",
                position: "absolute",
                top: "0px",
              }}
            />
            <p>{warningText}</p>
            {/* {warningType === "exceeded" && (
              <button onClick={() => {
                setWarningVisible(false);
                setIsWarningDismissed(true); // Mark the warning as dismissed
              }}>×</button>
            )} */}
          </div>
        )}
      </>
    );
  };

  // This branch unmounts the whole page, so for the few seconds between
  // allowing the camera and the first question appearing, the candidate saw
  // the content vanish and a bare spinner sit on an empty background. It read
  // as the page having reloaded, right at the most anxious moment of the
  // assessment. Saying what is happening costs nothing and stops it looking
  // like something went wrong.
  if (isLoading) {
    return (
      <div className="spinner">
        <SoftBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          sx={{ minHeight: "100vh", px: 3, textAlign: "center" }}
        >
          <SoftTypography variant="h5" sx={{ color: "#344767", mb: 1 }}>
            Preparing your assessment
          </SoftTypography>
          <SoftTypography variant="button" sx={{ color: "#67748e", mb: 4 }}>
            This takes a few seconds. Please do not close or refresh this page.
          </SoftTypography>
          <MySpinner />
        </SoftBox>
      </div>
    );
  }

  // Anti-copy: block copy/cut/select-all shortcuts, allow paste in input fields
  const handleKeyDown = (e) => {
    const tag = e.target.tagName;
    const isInput = tag === "INPUT" || tag === "TEXTAREA" || e.target.isContentEditable;
    if ((e.ctrlKey || e.metaKey) && (e.key === "c" || e.key === "C" || e.key === "a" || e.key === "A")) {
      if (!isInput || e.key === "c" || e.key === "C") {
        e.preventDefault();
      }
    }
    if ((e.ctrlKey || e.metaKey) && (e.key === "x" || e.key === "X")) {
      e.preventDefault();
    }
  };

  return (
    <div
      className="container"
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
      onKeyDown={handleKeyDown}
      style={{ userSelect: "none", WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none" }}
    >
      <Banner showBackButton={false} />
      <div
        className="row justify-content-center mt-5"
        // style={{ padding: "10px" }}
      >
        <div className="col-md-8 col-sm-12">
          {user && (
            <div>{/* <h1>{`${user.firstName} ${user.lastName}`}</h1> */}</div>
          )}
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{
              width: "1px",
              height: "1px",
              opacity: 0,
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: -1,
              pointerEvents: "none",
            }}
          />
          <canvas ref={canvasRef} style={{ display: "none" }} />
          {renderStep()}
        </div>
      </div>
    </div>
  );
}
